import React, { Component } from "react";
import { Box } from "reflexbox";

import Background from "../../../images/leaves.jpg";

class Home extends Component {
  render() {
    return (
      <div
        // style={{
        //   backgroundImage: `url(${Background})`,
        //   height: "calc(100% - 50px)",
        //   width: "100%",
        //   backgroundSize: "cover"
        // }}
      >
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/App/Static/Services.js